import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { BookOpen, Clock } from "lucide-react";

export default function PendingApproval() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  // If somehow approved/admin, send to dashboard
  React.useEffect(() => {
    if (user === false) navigate("/login");
    else if (user && (user.role === "admin" || user.status === "approved")) navigate("/dashboard");
  }, [user, navigate]);

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF7EE] px-6">
      <div className="max-w-lg text-center">
        <div className="flex items-center justify-center gap-2 mb-8">
          <BookOpen className="w-6 h-6 text-[#C46B4E]" strokeWidth={1.6} />
          <span className="font-heading text-2xl">The Peace Plot</span>
        </div>
        <div className="w-16 h-16 rounded-full bg-[#E7DFCE] flex items-center justify-center mx-auto">
          <Clock className="w-7 h-7 text-[#3D5844]" />
        </div>
        <h1 className="font-heading text-4xl text-[#2A2621] mt-6">Your request is being welcomed</h1>
        <p className="text-[#615A50] mt-3 leading-relaxed">
          Thank you, {user?.name || "friend"}. The Peace Plot is an invite-only collective, so one of our
          community leaders will review your request soon. You'll be able to enter the sanctuary the moment
          you're approved.
        </p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <button onClick={() => window.location.reload()} data-testid="pending-refresh"
            className="px-5 py-2.5 rounded-full bg-[#3D5844] text-white font-medium hover:bg-[#2F4535] transition-colors">
            Check again
          </button>
          <button onClick={handleLogout} data-testid="pending-logout"
            className="px-5 py-2.5 rounded-full border border-[#D5CEBF] text-[#2A2621] font-medium hover:bg-[#F3EFE4] transition-colors">
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
